import image from './images/page-not-found.svg';
import ErrorPageLayout from 'pages/Error/ErrorPageLayout';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const ErrorPage = () => {
    const history = useHistory();
    const { t } = useTranslation();
    const handleGoBack = () => {
        if (window.history.length > 1) return history.goBack();
        return history.push('/');
    };

    return (
        <ErrorPageLayout
            action={{ label: t('common:errors.go-back', 'Go Back'), onClick: handleGoBack }}
            description={t(
                'common:errors.page-not-found-description',
                'Oops! It seems there was an issue.\nPlease return to the previous page or head back to the Course Lobby.'
            )}
            image={image}
            imageAlt={t('common:errors.page-not-found-illustration', 'Page not found illustration')}
            imageHeight={337}
            imageWidth={282}
            title={t('common:errors.page-not-found-title', 'Page Not Found')}
        />
    );
};

export default ErrorPage;
